"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentsTokens = void 0;
const components_1 = require("../components");
exports.componentsTokens = {
    ...components_1.components.input,
    ...components_1.components.button,
    ...components_1.components.chip,
    ...components_1.components.checkbox,
    ...components_1.components.radio,
    ...components_1.components.pinInput,
    ...components_1.components.progressBar,
    ...components_1.components.select,
    ...components_1.components.card,
    ...components_1.components.switch,
};
